module.exports = __webpack_public_path__ + "assets/cartilage-d6f892043f153d411b144b5a5dce6c4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/data/images/cartilage.jpg
// module id = 507
// module chunks = 1